import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DisplayComponent from '../BaseComponents/DisplayComponent';

import Header from '../Type/Header';
import Button from '../Link/Button';
import Grid from '../Grid/Grid';
import Cell from '../Grid/Cell';
import Section from '../Grid/Section';

import './Tile.module.css';
import { InteractiveDiv } from 'formlabs-web-components/Wrapper';
import useIsMobile from '../../../hooks/useIsMobile';

const TileGroup = ({
  title,
  copy,
  ctaText,
  ctaUrl,
  tileStyle,
  tileGroupId,
  children,
  buttonColor,
  navTitle,
  spaceAbove,
  numOfCols = 4
}) => {
  const [open, setOpen] = useState(true);
  const mobile = useIsMobile(640);
  const groupToggle = () => {
    setOpen(!open);
  };

  const isOpen = !navTitle ? true : open;

  const totalTiles = children.length;
  const childrenArray = React.Children.map(children, (child, index) => {
    if (totalTiles === index + 1) {
      return React.cloneElement(child, {
        tileStyle,
        lastChild: true
      });
    }
    return React.cloneElement(child, {
      tileStyle
    });
  });

  return (
    <Section
      hasContainer
      sectionId={tileGroupId}
      marginBefore={spaceAbove}
      marginBeforeSmall={spaceAbove}
      marginBeforeMedium={spaceAbove}
    >
      {(title || copy) && (
        <Grid direction="x" primaryAlignment="align-center">
          <Cell largeSize={12}>
            <div style={{ textAlign: 'center' }}>
              <Header level={4} displayAs={4}>
                {title}
              </Header>

              <p>{copy}</p>
            </div>
          </Cell>
        </Grid>
      )}
      {navTitle && mobile && (
        <InteractiveDiv
          styleName={`mobile-list-nav open-${isOpen}`}
          handler={groupToggle}
        >
          {navTitle}
        </InteractiveDiv>
      )}
      <Grid direction="x" primaryAlignment="align-center">
        {childrenArray.map((child, index) => (
          <Cell
            largeSize={`${Math.floor(24 / numOfCols)}`}
            mediumSize="12"
            key={index}
          >
            {child}
          </Cell>
        ))}
      </Grid>
      {ctaText && ctaUrl && (
        <Grid direction="x" primaryAlignment="align-center">
          <div styleName="button-container">
            <Button color={buttonColor} url={ctaUrl}>
              {ctaText}
            </Button>
          </div>
        </Grid>
      )}
    </Section>
  );
};

TileGroup.propTypes = {
  title: PropTypes.string,
  copy: PropTypes.string,
  tileGroupId: PropTypes.string,
  ctaText: PropTypes.string,
  ctaUrl: PropTypes.string,
  tileStyle: PropTypes.string,
  children: PropTypes.node,
  buttonColor: PropTypes.string,
  navTitle: PropTypes.string
};

export default DisplayComponent(TileGroup);
